import React from "react";
import { Switch, Route } from "react-router";

import { IdentifiedSubscription } from "../../store/models/subscriptions.interface";

import Home from "../Home/Home";

import EventsOverview from "../Events/EventsOverview";
import EventsList from "../Events/EventsList";
import AttendeesList from "../Events/AttendeesList";
import EventAttendeesList from "../Events/EventAttendeesList";

import Marketing from "../Marketing/Marketing";
import Reports from "../Reports/Reports";
import Subscription from "../DataPacks/Subscription";

interface RoutesProps {
  showMarketing?: boolean;
  showReports?: boolean;
  subscriptions?: IdentifiedSubscription[];
}

const Routes: React.FC<RoutesProps> = ({
  showMarketing,
  showReports,
  subscriptions,
}) => (
  <Switch>
    <Route
      path="/events/list"
      component={EventsList}
      exact
    />
    <Route
      path="/events/attendees"
      component={AttendeesList}
      exact
    />
    <Route
      path="/events/:eventId/:ticketId/attendees"
      component={EventAttendeesList}
    />
    <Route
      path="/events"
      component={EventsOverview}
    />
    {!!showMarketing && (
      <Route
        path="/marketing"
        component={Marketing}
      />
    )}
    {!!showReports && (
      <Route
        path="/reports"
        component={Reports}
      />
    )}
    {!!subscriptions && subscriptions.map(x => (
      <Route
        key={x.id}
        path={`/data/${x.id}`}
        component={Subscription}
      />
    ))}
    <Route
      path=""
      component={Home}
    />
  </Switch>
);

export default Routes;
